// Transitional shim — LinkType moved to fym-shared so the sml-preview website
// (which may not depend on fym-common) shares one definition. The recognising
// function below stays here. Remove the re-export no sooner than 2026-08-22.
import { LinkType } from 'fym-shared/src/smartlinks/linkTypes';

export { LinkType } from 'fym-shared/src/smartlinks/linkTypes';

const musicServices = [
  LinkType.amazonmusic,
  LinkType.applemusic,
  LinkType.deezer,
  LinkType.pandora,
  LinkType.soundcloud,
  LinkType.spotify,
  LinkType.tidal,
  LinkType.youtube,
  LinkType.youtubemusic,
  LinkType.napster,
  LinkType.qobuz,
  LinkType.qqmusic,
  LinkType.yandexmusic,
  LinkType.vkmusic,
  LinkType.zvuk,
  LinkType.gaana,
  LinkType.jiosaavn,
  LinkType.resso,
  LinkType.boomplay,
  LinkType.audius,
];

export function isMusicService(linkType: LinkType) {
  return musicServices.includes(linkType);
}

export function recognizeLinkTypeByUrl(url: { host: string }): LinkType {
  const { host } = url;
  if (host.includes('facebook')) {
    return LinkType.facebook;
  }
  if (host.includes('instagram')) {
    return LinkType.instagram;
  }
  if (host.includes('twitter')) {
    return LinkType.twitter;
  }
  if (host.includes('music.youtube')) {
    return LinkType.youtubemusic;
  }
  if (host.includes('youtube') || host.includes('youtu.be')) {
    return LinkType.youtube;
  }
  if (host.includes('linkedin')) {
    return LinkType.linkedin;
  }
  if (host.includes('soundcloud')) {
    return LinkType.soundcloud;
  }
  if (host.includes('tidal')) {
    return LinkType.tidal;
  }
  if (host.includes('amazon')) {
    return LinkType.amazonmusic;
  }
  if (host.includes('tiktok')) {
    return LinkType.tiktok;
  }
  if (host.includes('music.apple')) {
    return LinkType.applemusic;
  }
  if (host.includes('deezer')) {
    return LinkType.deezer;
  }
  if (host.includes('pandora')) {
    return LinkType.pandora;
  }
  if (host.includes('spotify')) {
    return LinkType.spotify;
  }
  if (host.includes('tidal')) {
    return LinkType.tidal;
  }
  if (host.includes('napster')) {
    return LinkType.napster;
  }
  if (host.includes('qobuz')) {
    return LinkType.qobuz;
  }
  if (host.includes('qq.com')) {
    return LinkType.qqmusic;
  }
  if (host.includes('music.yandex.ru')) {
    return LinkType.yandexmusic;
  }
  if (host.includes('vk.com')) {
    return LinkType.vkmusic;
  }
  if (host.includes('zvuk')) {
    return LinkType.zvuk;
  }
  if (host.includes('gaana.com')) {
    return LinkType.gaana;
  }
  if (host.includes('jiosaavn.com')) {
    return LinkType.jiosaavn;
  }
  if (host.includes('resso.com')) {
    return LinkType.resso;
  }
  if (host.includes('boomplay.com') || host.includes('boomplaymusic.com')) {
    return LinkType.boomplay;
  }
  if (host.includes('reddit.com')) {
    return LinkType.reddit;
  }
  if (host.includes('snapchat.com')) {
    return LinkType.snapchat;
  }
  if (host.includes('audiomack.com')) {
    return LinkType.audiomack;
  }
  if (host.includes('audius.co')) {
    return LinkType.audius;
  }

  return LinkType.generic;
}
